import { render, staticRenderFns } from "./real-stories.vue?vue&type=template&id=31223e6a&scoped=true"
import script from "./real-stories.vue?vue&type=script&lang=js"
export * from "./real-stories.vue?vue&type=script&lang=js"
import style0 from "./real-stories.vue?vue&type=style&index=0&id=31223e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31223e6a",
  null
  
)

export default component.exports